import {createContext, useEffect, useState} from 'react';
import request from './request';

export const SessionStore = createContext({
    project: {
        id: '',
    },
    user: {
        id: '',
    },
});

export function useUserSession(isGetSession = true) {
    const [session, setSession] = useState({});
    useEffect(() => {
        if (isGetSession) {
            (async () => {
                const res = await request.get('/idgate/v1/user/session');
                setSession(res);
            })();
        }

    }, [isGetSession]
    );
    return session;
}

export const ConfigStore = createContext({});
